import { resetAllState } from "../../../store/actions/user";
import Config from "../../config";

/**
 * * Action types, typed in order to eliminate bugs due to misspellings. Should be read-only.
 */
export const actionTypes = Object.freeze({
    TOGGLE_NAV_PANEL: 'TOGGLE_NAV_PANEL',
    SET_NAV_PANEL_FLAG: 'SET_NAV_PANEL_FLAG'
});

export const toggleNavPanel = () => ({
    type: actionTypes.TOGGLE_NAV_PANEL
});

/**
 * @param {boolean} data
 */
export const setNavPanelFlag = data => ({
    type: actionTypes.SET_NAV_PANEL_FLAG,
    payload: data
});

export function scrollToTop(condition) {
    if (condition) {
        return (dispatch) => {
            dispatch({
                type: 'SCROLL_TO_TOP_ENABLE'
            });

            return Promise.resolve(true);
        }
    } else {
        return (dispatch) => {
            dispatch({
                type: 'SCROLL_TO_TOP_DISABLE'
            });

            return Promise.resolve(true);
        }
    }
}

export function showTopBar() {
    return (dispatch) => {
        dispatch({
            type: 'SHOW_TOP_BAR'
        });

        return Promise.resolve(true);
    }
}

export function hideTopBar() {
    return (dispatch) => {
        dispatch({
            type: 'HIDE_TOP_BAR'
        });

        return Promise.resolve(true);
    }
}

export function showNavBar() {
    return (dispatch) => {
        dispatch({
            type: 'SHOW_NAV_BAR'
        });

        return Promise.resolve(true);
    }
}

export function hideNavBar() {
    return (dispatch) => {
        dispatch({
            type: 'HIDE_NAV_BAR'
        });

        return Promise.resolve(true);
    }
}

export function showSubBar() {
    return (dispatch) => {
        dispatch({
            type: 'SHOW_SUB_BAR'
        });

        return Promise.resolve(true);
    }
}

export function hideSubBar() {
    return (dispatch) => {
        dispatch({
            type: 'HIDE_SUB_BAR'
        });

        return Promise.resolve(true);
    }
}

export function setActiveSubBar(activeSubBar) {
    return dispatch => {
        dispatch({
            type: 'SET_ACTIVE_SUB_BAR',
            payload: activeSubBar
        });

        return Promise.resolve(true);
    }
}

export function setVersion() {
    return (dispatch) => {
        dispatch(resetAllState());

        dispatch({
            type: 'LAYOUT_SET_VERSION',
            payload: Config.version
        });

        return Promise.resolve(true);
    }
}


// WEBPACK FOOTER //
// ./src/core/admin/store/actions/layout.js